import request from '../static/js/request'
import { getformData } from '@/static/js/zjs'
import { getPlatform } from '../static/js/zjs'
import { ossUrl } from '../static/js/oss'
import { Math } from 'core-js'

/**
 * 通用可维护弹窗
 * @param {Object} data 请求体
 * @return {Promise} 响应体{data,code,videoCourseAd}
 */
export function getVideoCourseAd(data) {
  return request
    .post(
      `/cms/weixin/video/findOtherAdByType/${data.id}`,
      getformData({
        isCheckTime: data.isCheckTime || true,
        vipLevel: data.vipLevel
      })
    )
    .then((res) => res.data)
}

class MopaAdFilter {
  static JSONLIST = {}

  constructor(options = {}) {
    const { data, code, cCodes, svEndDay, vipLevel, equipment } = options
    this.data = data
    this.code = code
    this.cCodes = cCodes
    this.svEndDay = svEndDay
    this.vipLevel = vipLevel
    this.equipment = equipment
  }

  request = request

  async getMopaAdJSON(codeargs) {
    const code = codeargs || this.code
    const appid = getPlatform().appid
    let res = {
      data: []
    }
    try {
      const local = MopaAdFilter.JSONLIST[this.code]
      if (local) {
        res.data = local
      } else {
        res = await request.get(
          this.url || ossUrl('/adv/' + appid + '/' + code + '.json?' + Math.random()),
          {
            notShowToast: true
          }
        )
      }
    } catch (e) {}
    this.originData = res.data || []
    this.data = res.data || []
    MopaAdFilter.JSONLIST[this.code] = res.data
    return this
  }

  filterPlace(cCodesagrs) {
    const cCodes = cCodesagrs || this.cCodes
    const result = (this.originData.find((i) => i.code === cCodes) || {}).details || []
    this.data = result
    return this
  }

  filterSvEndDay(svEndDayargs) {
    const svEndDay = svEndDayargs || this.svEndDay
    const result = this.data.filter(
      (item) => !(svEndDay && Number(svEndDay) > Number(new Date(item.svEndDay)))
    )
    this.data = result
    return this
  }

  filterAuthes(vipLevelargs) {
    const vipLevel = vipLevelargs || this.vipLevel || ''
    const result = this.data.filter((item) => {
      const authes = item.authes || []
      if (authes.length > 0) {
        return authes.includes(vipLevel.toUpperCase())
      } else {
        return true
      }
    })
    this.data = result
    return this
  }

  filterEquipment(equipmentargs) {
    const equipment = equipmentargs || this.equipment
    const result = this.data.filter((item) => {
      const devices = item.devices || []
      return (devices.length > 0 ? devices : ['IOS', 'ANDROID']).includes(
        equipment ? 'IOS' : 'ANDROID'
      )
    })
    this.data = result
    return this
  }

  filterAll(options = {}) {
    return this.filterPlace(options.cCodes)
      .filterSvEndDay(options.svEndDay)
      .filterEquipment(options.equipment)
      .filterAuthes(options.vipLevel)
  }

  getData() {
    return this.data
  }

  getOriginData() {
    return this.originData
  }
}

/**
 * getMopaAd 链式调用
 */
export function getMopaAdChain(options) {
  return new MopaAdFilter(options)
}

// ad json
export function getMopaAdJSON(code) {
  const appid = getPlatform().appid
  return request.get(ossUrl('/adv/' + appid + '/' + code + '.json?' + Math.random()), {
    notShowToast: true
  })
}

/**
 * MOPA可维护弹窗
 * @param {Object} data 请求体{code,cCodes}
 * @return {Promise} 响应体[]
 */
export async function getMopaAd(data, vipLevel, equipment, svEndDay) {
  // console.log(data, vipLevel, equipment, svEndDay)
  const filter = await getMopaAdChain({
    code: data.code,
    cCodes: data.cCodes,
    vipLevel,
    svEndDay,
    equipment
  }).getMopaAdJSON()
  const res = filter.filterAll().getData()
  return res
}

/**
 * MOPA可维护弹窗
 * @param {Object} data 请求体{code,cCodes}
 * @return {Promise} 响应体[]
 */
export async function getViewHomeMediaList({ vip = 'NV' }) {
  const appid = getPlatform().appid
  const device = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ? 'IOS' : 'ANDROID'
  let list = await request
    .get(ossUrl('/adv/' + appid + '/' + 'viewHome.json?' + Math.random()))
    .then((res) => res.data)
  const ret = {
    banner: null,
    adIcon: null,
    popup: null,
    across: null
  }
  list = list.map((item) => {
    item.details = item.details.filter((detail) => {
      return detail.devices.indexOf(device) > -1 && detail.authes.indexOf(vip.toUpperCase()) > -1
    })
    return item
  })
  list.forEach((item) => {
    ret[item.code] = item
  })

  return ret
}

export function getPlatformJSON() {
  return request(`/cms/webapp/home/static/platform.json?${new Date().valueOf()}`)
}

/**
 * MOPA首页icon可维护弹窗
 * @param {Object} data 请求体{code,cCodes}
 * @return {Promise} 响应体[]
 */
export function getIconMopaAd(data, vipLevel, equipment, svEndDay) {
  const appid = getPlatform().appid
  return (
    request
      .get(ossUrl('/icon/' + appid + '/' + data.code + '.json?' + Math.random()))
      // 找到当前位置的广告数据
      .then((res) => (res.data.find((i) => i.code === data.cCodes) || {}).details || [])
      // 校验sv
      .then((res) => {
        return res.filter((item) => {
          const authes = item.authes || []
          return (authes.length > 0 ? authes : ['SV', 'NV']).includes(vipLevel.toUpperCase())
        })
      })
      // 校验用户设备
      .then((res) => {
        return res.filter((item) => {
          const devices = item.devices || []
          return (devices.length > 0 ? devices : ['IOS', 'ANDROID']).includes(
            equipment ? 'IOS' : 'ANDROID'
          )
        })
      })
  )
}
